import { Skeleton } from '~/shared/ui/SkeletonList'

export function LoadingBlock() {
  return (
    <>
      <Skeleton
        animated
        $height={24}
        style={{ marginBottom: '12px', marginTop: '12px' }}
      />
      <Skeleton animated $height={24} style={{ marginBottom: '12px' }} />
      <Skeleton animated $height={24} style={{ marginBottom: '24px' }} />

      <Skeleton animated $height={24} style={{ marginBottom: '26px' }} />

      <Skeleton animated $height={44} style={{ marginBottom: '0' }} />
    </>
  )
}
